export default __webpack_public_path__ + "static/media/Heaven's Jang Bong.511ff35d.jpg";